import { Chat } from 'pricing-pages-ui/v2/utils/chat/Chat';

// Chat tracking setup doesn't need to block the critical path. Defer until the
// browser is idle so it runs after first paint and chunk parsing. Fall back to
// setTimeout for browsers that don't support requestIdleCallback (e.g. Safari).
export function setupChatTracking() {
  const idleCallback = window.requestIdleCallback;
  if (typeof idleCallback === 'function') {
    idleCallback(() => {
      Chat.setupTracking('public');
    });
  } else {
    setTimeout(() => {
      Chat.setupTracking('public');
    }, 0);
  }
}